module.exports = __webpack_public_path__ + "static/img/xueshengguanli.c944d460.png";